import Button from '@components/Button/Button';
import Divider from '@components/Divider/Divider';
import Flex from '@components/Flex/Flex';
import Text from '@components/Text/Text';
import { Box, lighten, styled } from '@mui/material';

export const StyledBoxContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active: boolean }>(({ theme, active }) => ({
  border: `1px solid`,
  borderColor: active ? theme.palette.primary.main : theme.palette.divider,
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  position: 'relative',
  borderRadius: theme.spacing(10),
  cursor: active ? 'pointer' : 'default',
  overflow: 'hidden',
  maxWidth: 700,
  [theme.breakpoints.down('sm')]: {
    padding: 'auto',
  },
}));

export const StyledNotifyButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(16),
  '&:disabled': {
    backgroundColor: theme.palette.divider,
  },
}));

export const StyledTopBoxContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active: boolean }>(({ theme, active }) => ({
  backgroundColor: lighten(
    active ? theme.palette.primary.main : theme.palette.divider,
    0.9
  ),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  borderTopLeftRadius: theme.spacing(10),
  borderTopRightRadius: theme.spacing(10),
  padding: theme.spacing(13, 15),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(12, 8),
  },
}));

export const StyledTitleText = styled(Text)(({ theme }) => ({
  marginTop: theme.spacing(15),
  [theme.breakpoints.down('sm')]: {
    marginTop: theme.spacing(12),
  },
  textAlign: 'center',
}));

export const StyledDescriptionText = styled(Text)(({ theme }) => ({
  marginTop: theme.spacing(4),
  [theme.breakpoints.down('sm')]: {
    marginTop: theme.spacing(8),
  },
  textAlign: 'center',
}));

export const StyledViewDetailButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(11),
  [theme.breakpoints.down('sm')]: {
    marginTop: theme.spacing(8),
  },
}));

export const StyledFeatureBoxContainer = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(11),
  paddingBottom: theme.spacing(15),
  paddingLeft: theme.spacing(5),
  paddingRight: theme.spacing(5),
  [theme.breakpoints.down('sm')]: {
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(9),
  },
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexWrap: 'wrap',
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  marginRight: theme.spacing(16),
  marginLeft: theme.spacing(16),
  [theme.breakpoints.down('md')]: {
    marginRight: theme.spacing(8),
    marginLeft: theme.spacing(8),
  },
}));

export const StyledPortfolioBoxContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(16, 15),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(11, 9),
  },
}));

export const StyledPortfolioPhotoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexWrap: 'wrap',
  paddingTop: theme.spacing(5),
  gap: theme.spacing(8),
  height: 60,
  [theme.breakpoints.down('lg')]: {
    height: 'auto',
  },
}));

export const StyledPortfolioPhoto = styled('img')(({ theme }) => ({
  paddingTop: theme.spacing(5),
  maxHeight: 27,
}));

export const StyledBlurContainer = styled(Flex)(({ theme }) => ({
  backdropFilter: 'blur(10px)',
  position: 'absolute',
  top: 0,
  right: 0,
  flex: 1,
  width: '100%',
  minHeight: '100%',
  borderRadius: theme.spacing(11),
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  textAlign: 'center',
  padding: theme.spacing(0, 15),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0, 8),
  },
}));
